import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pagination: { page: 0, pageSize: 15 },
  sortModel: [{ field: "package_Name", sort: "desc" }],
  searchText: "",
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    resetPage: state => {
      state.pagination.page = 0;
    },
    resetDepartmentState: state => Object.assign(state, initialState),
  },
});

export const { setPagination, setSortModel, setSearchText, resetDepartmentState,resetPage} = departmentSlice.actions;
export default departmentSlice.reducer;
